import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "crm:flex crm:items-center" }
const _hoisted_2 = { class: "crm:ml-4" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "crm:flex crm:items-center" }

import {reactive, watch, inject} from 'vue';
import Questionario from "../../composable/Questionario.class";


export default {
  __name: 'AppChecklistMatriceRichiesta',
  props: {
  /**
   * documento da richiedere
   */
  document: {
    type: Object,
    default() {
      return {}
    },
    required: true
  },
  /**
   * valori di default del documento da richiedere
   * utilizzato ad esempio in modalità carica modello checklist
   */
  defaultData: {
    type: Object,
    default() {
      return {}
    }
  },
  /**
   * sezione alla quale la richiesta di documento appartiene
   */
  section: {
    type: String,
    default: ''
  }
},
  setup(__props) {

/**
 * @doc
 * Si occupa di renderizzare e gestire le singole richieste di documenti della checklist
 * espone anche il campo di testo per la casistica di aggiunta richiesta documento personalizzato
 */
const props = __props

const $L_ = inject('$L_');

const formatoRichiestaDocumenti = [
  {
    name: 'originale',
    value: 'originale'
  },
  {
    name: 'In fotocopia',
    value: 'in_fotocopia'
  },
  {
    name: 'In copia conforme cartacea',
    value: 'in_copia_conforme_cartacea'
  },
  {
    name: 'In copia conforme digitale',
    value: 'in_copia_conforme_digitale'
  }
]

const richiesta = reactive({
  active: props.defaultData ? Object.keys(props.defaultData).length > 0 ? '1' : '0' : '0',
  formato: {value: props.defaultData ? props.defaultData.formato : null},
  label: props.defaultData ? props.defaultData.label : ''
})

// utilizzato per formattare e aggiornare le richieste in base al cambio valori
// ad ogni aggiornamento viene anche rifreshato l'hash generato
const updateRichiesta = inject('updateRichiesta');
watch(() => richiesta, (newValue) => {
  updateRichiesta({...newValue, ...{category_ref: props.section, hash: Questionario._generateHash(), id: parseInt(Math.round(Math.random() * 1000))}}, props.document)
}, { deep: true, immediate: true })

// metodi per l'aggiornamento del valore in caso di documento personalizzato
const composeVModel = (documentLabel, isActive) => ({value: documentLabel, required: (documentLabel === '' && isActive)})
const updateVModel = (event) => richiesta.label = event.value;

return (_ctx, _cache) => {
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_select = _resolveComponent("base-select")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_input_checkbox, {
        name: __props.document.title,
        "is-flat": true,
        value: richiesta.active,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => ((richiesta.active) = $event))
      }, null, 8 /* PROPS */, ["name", "value"]),
      _createElementVNode("div", _hoisted_2, [
        (!__props.document.custom)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              class: "crm:mb-0",
              for: __props.document.title
            }, _toDisplayString(__props.document.label), 9 /* TEXT, PROPS */, _hoisted_3))
          : (_openBlock(), _createBlock(_component_base_input_text, {
              key: 1,
              class: "text-left placeholder-left crm:w-[300px]",
              name: `input-doc-${__props.defaultData.keyMap}`,
              validateTo: composeVModel(richiesta.label, richiesta.active),
              "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => (updateVModel($event))),
              placeholder: "Inserisci il nome del documento da caricare"
            }, null, 8 /* PROPS */, ["name", "validateTo"]))
      ])
    ]),
    (richiesta.active === '1')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "me-2" }, "Forma del documento", -1 /* CACHED */)),
            _createVNode(_component_base_select, {
              name: "forma",
              options: formatoRichiestaDocumenti,
              validateTo: richiesta.formato,
              "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((richiesta.formato) = $event))
            }, null, 8 /* PROPS */, ["validateTo"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}